/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dizzy_Direct_Lark_FlopInputs */

const fr_dizzy_direct_lark_flop = /** @type {(inputs: Dizzy_Direct_Lark_FlopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il n'y a aucun paiement lié a cette demande`)
};

/**

* @param {Dizzy_Direct_Lark_FlopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dizzy_direct_lark_flop = /** @type {((inputs?: Dizzy_Direct_Lark_FlopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dizzy_Direct_Lark_FlopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dizzy_direct_lark_flop(inputs)
});